// React
import { useCallback } from 'react';

// Kendo
import { Switch as KendoSwitch } from '@progress/kendo-react-inputs';

const Switch = (fieldRenderProps) => {
    const { value, onChange, onLabel, offLabel, ...others } = fieldRenderProps;

    const onValueChange = useCallback(() => {
        onChange({ value: !value });
    }, [ onChange, value ]);

    return (
        <KendoSwitch
            onChange={ onValueChange }
            checked={ value }
            id={ others.id }
            onLabel={ onLabel }
            offLabel={ offLabel }
        />
    );
};

export default Switch;
